export default "__VITE_ASSET__1JvZECdN7aT0jIhwi0Zsww__"